import { render, staticRenderFns } from "./ModalFormularioPlanPagoUniversidad.vue?vue&type=template&id=82a7abfc"
import script from "./ModalFormularioPlanPagoUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormularioPlanPagoUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports